import React from "react";
import {Redirect} from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "src/hooks/useAuth";
import {URL_TEMPLATES as URL} from "src/urlTemplates";

const AdminGuard = ({children}) => {
    const {hasAdminRole} = useAuth();

    if (!hasAdminRole()) {
        return <Redirect to={URL._404}/>;
    }

    return <>{children}</>;
};

AdminGuard.propTypes = {
    children: PropTypes.node
};

export default AdminGuard;
